import React from "react";
import {pad} from "../utils";
import store from "../AppState";

export default class Main extends React.Component {
    constructor() {
        super();
        this.state = {
            data: null,
            total: 0,
            progress: 0,
            visibleRooms: []
        };
    }

    componentDidMount() {
        this.loadWidget();

        this.setState({
            stylePath: this.props.params.widget + '.css'
        });
    }

    componentDidUpdate(prevProps) {
        let oldId = prevProps.params.widget;
        let newId = this.props.params.widget;
        if (newId !== oldId) {
            this.loadWidget();
        }
    }

    loadWidget() {
        let baseUrl;

        fetch(`${process.env.REACT_APP_API_URL}/${this.props.params.widget}`)
            .then((response) => response.json())
            .then((responseJson) => {
                store.data = responseJson;
                if (responseJson.sunstudios) {
                    this.preloadSunstudies(responseJson.sunstudios).then(done => {
                        this.setState({
                            data: responseJson
                        });
                    });
                }

                this.setState({
                    data: responseJson
                });
            });
    }

    render() {
        if (!this.state.data) {
            const progressStyle = {
                width: ((this.state.progress / this.state.total) * 100) + '%'
            };

            return (<div className="cw-main-loader">
                <p>Laddar</p>
                <div className="progress">
                    <div className="progress-bar" style={progressStyle} role="progressbar"
                         aria-valuenow={this.state.progress} aria-valuemin="0" aria-valuemax={this.state.total}></div>
                </div>
            </div>);
        }

        const childrenWithProps = React.Children.map(this.props.children,
            (child) => React.cloneElement(child, {
                data: this.state.data
            })
        );

        const stylePath = `/templates/${this.state.data.template}/css/style.css`;

        return (
            <div className="cw-main">
                <link rel="stylesheet" type="text/css" href={stylePath}/>
                {childrenWithProps}
            </div>)
    }


    preloadSunstudies(sunstudios) {
        return new Promise((resolve, reject) => {

            let promises = [];

            sunstudios.forEach(sunstudy => {
                sunstudy.dates.forEach(date => {
                    for (let i = 1; i <= date.nImages; i++) {
                        const num = pad('0000', i, true);
                        const url = `${`https://webservices.carbonwhite.se${date.path}/${num}.jpg`}`;

                        promises.push(new Promise((imgResolve, imgReject) => {
                            let image = new Image();
                            image.addEventListener("load", () => {
                                imgResolve();
                                this.setState((prevState, props) => ({
                                    progress: prevState.progress + 1
                                }));
                            }, false);
                            image.src = url;
                        }));
                    }

                    this.setState((prevState, props) => ({
                        total: prevState.total + date.nImages
                    }));
                });
            });

            resolve();

            Promise.all(promises).then(values => {
                resolve();
            })
        });
    }
}


// WEBPACK FOOTER //
// ./src/components/Main.jsx